// extracted by mini-css-extract-plugin
export default {"bsepa":"home_bsepa__H5Y0J","ranking":"home_ranking__HSjsH","rankingTitle":"home_rankingTitle__9obq1"};